import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { GameController, ArrowLeft } from '@phosphor-icons/react';
import { LoginForm } from './auth/LoginForm';
import { RegisterForm } from './auth/RegisterForm';
import { ForgotPasswordForm } from './auth/ForgotPasswordForm';
import { useNavigate } from 'react-router-dom';

export const AuthPage = ({ onAuthSuccess }) => {
  const navigate = useNavigate();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-md">
        <Button
          variant="ghost"
          onClick={() => navigate('/')}
          className="mb-6 text-[#71717A] hover:text-[#09090B]"
          data-testid="back-to-landing"
        >
          <ArrowLeft size={18} className="mr-2" />
          Back to Home
        </Button>

        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="bg-[#0047FF] p-4">
              <GameController size={48} weight="fill" color="#FFFFFF" />
            </div>
          </div>
          <h1 className="font-heading text-4xl font-bold tracking-tight text-[#09090B] mb-2">
            DashLink Gaming
          </h1>
          <p className="text-[#71717A] text-sm">Connect, compete, and dominate</p>
        </div>

        {showForgotPassword ? (
          <ForgotPasswordForm onBack={() => setShowForgotPassword(false)} />
        ) : (
          <Tabs defaultValue="login" className="w-full">
            <TabsList className="grid w-full grid-cols-2 mb-6 bg-[#FAFAFA] border border-[#E4E4E7]">
              <TabsTrigger value="login" data-testid="login-tab">Login</TabsTrigger>
              <TabsTrigger value="register" data-testid="register-tab">Register</TabsTrigger>
            </TabsList>

            <TabsContent value="login">
              <LoginForm 
                onAuthSuccess={onAuthSuccess}
                onForgotPassword={() => setShowForgotPassword(true)}
              />
            </TabsContent>

            <TabsContent value="register">
              <RegisterForm onAuthSuccess={onAuthSuccess} />
            </TabsContent>
          </Tabs>
        )}
      </div>
    </div>
  );
};
